const TabTrigger = (_) => null;
export default TabTrigger;
